import { render, staticRenderFns } from "./rMediumEditorBlock.vue?vue&type=template&id=0a27abf0"
import script from "./rMediumEditorBlock.vue?vue&type=script&lang=js"
export * from "./rMediumEditorBlock.vue?vue&type=script&lang=js"
import style0 from "./rMediumEditorBlock.vue?vue&type=style&index=0&id=0a27abf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports